import React, { useEffect, useState } from "react";

// Fetches an auth-protected /api/files image and renders it as a blob URL.
export default function PodImage({ url, alt = "Proof of delivery", testid = "pod-photo-image", className = "mt-2 max-h-48 rounded-md border" }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let obj;
    const token = localStorage.getItem("kc_token");
    fetch(`${process.env.REACT_APP_BACKEND_URL}${url}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.blob() : Promise.reject()))
      .then((b) => { obj = URL.createObjectURL(b); setSrc(obj); })
      .catch(() => {});
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [url]);
  if (!src) return null;
  return <img src={src} alt={alt} className={className} data-testid={testid} />;
}
